__turbopack_context__.v({
  "avatar": "community-powered-badge-module-scss-module__5PQ3zq__avatar",
  "avatar-lg": "community-powered-badge-module-scss-module__5PQ3zq__avatar-lg",
  "avatar-sm": "community-powered-badge-module-scss-module__5PQ3zq__avatar-sm",
  "badge-container": "community-powered-badge-module-scss-module__5PQ3zq__badge-container",
  "badge-container-lg": "community-powered-badge-module-scss-module__5PQ3zq__badge-container-lg",
  "badge-container-sm": "community-powered-badge-module-scss-module__5PQ3zq__badge-container-sm",
  "community-powered": "community-powered-badge-module-scss-module__5PQ3zq__community-powered",
});
